import styled, { css } from 'styled-components';
import { playGrey10 } from '../design-tokens';
import { device } from '../breakpoints';
import { calc } from '../helpers';
import { regularOutline } from '../typography/helpers';
import { Heading } from './components/Caption/Caption.styles';
import { PlayLinkContainer } from '../../components/Link';

export const cssShowCaseCard = css`
    display: block;
    width: 100%;
    background: ${playGrey10};
    margin: 0 0 5px;

    @media ${device.GteSmall} {
        ${(props) =>
            !props.big &&
            css`
                display: inline-block;
                ${calc('width', '50% - 2.5px', '49.6%')};
            `}
    }

    @media ${device.GteLarge} {
        margin: 0 0 10px;

        ${(props) =>
            !props.big &&
            css`
                display: inline-block;
                ${calc('width', '33.333% - 5px', '33%')};
            `}
    }

    ${(props) =>
        props.twoColumns &&
        css`
        ${
            props.big &&
            css`
                display: inline-block;
                ${calc('width', '50% - 2.5px', '49.6%')};
            `
        } 

        @media ${device.GteSmall} {
            ${
                props.big &&
                css`
                    ${calc('width', '33.333% - 2.5px', '33%')};
                `
            }
        }
    `}
`;

export const StyledShowcaseCard = styled.article`
    ${cssShowCaseCard}
`;

export const CardWrapper = styled(PlayLinkContainer)`
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    text-decoration: none;

    &:focus {
        ${regularOutline()};
    }

    &:active {
        outline: 0;
    }

    &:hover ${Heading} {
        text-decoration: underline;
    }
`;
